'use client';

import { TextPassage } from '@petsmart-ui/sparky';

import { useProduct } from '@/entities/product';

export const Sku = () => {
    const { product } = useProduct();

    return (
        <TextPassage data-testid="test-pdp-sku" className="product-details__number">
            Item #{product?.sku}
        </TextPassage>
    );
};
